import React, { Component } from 'react'
import axios from 'axios'
import RecoveryForm from './RecoveryForm'
import qs from 'qs'
import Layout from '../Layout'
import moment from 'moment'
import { OnboardingService } from '../../services/onboardingService'
import ValidationRules from '../../validation/validationRules'
// TODO: Consultar no onboarding
// TODO: Send IP Address By API Management
const onboardingCookieName = 'participantInfo'

class RecoveryAccessPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isConfirmationWithFiles: false,
      isConfirmation: false,
      isSendDocument: false,
      isResendSMS: false,
      isSendSMS: false,
      isResend: false,
      isSendEmail: false,
      isError: false,
      isExistsOnboardingBox: false,
      isApprovedOnboarding: false,
      emailAddress: '',
      cellPhone: '',
      login: '',
      idTransaction: '',
      idTransactionSms: '',
      token: '',
      tokenSms: '',
      filesUpload: [],
      isRecoveryAccess: false,
      isLookingUpContact: false,
      hasFile: false,
      isPassword: false,
      timeLeft: 180,
      isEnableToken: false,
      onboardingId: 0,
      createDate: ''
    }
  }

  componentDidMount() {
    const { login } = qs.parse(this.props.location.state)
    this.setState({ login: login })
    this.checkOnboardingStatus(login)
  }

  get onboardingBaseURI() {
    return `${process.env.RAZZLE_ONBOARDING_API}`
  }

  get campaignId() {
    return `${process.env.RAZZLE_CAMPAIGN_ID}`
  }

  get unmaskedCellphone() {
    const { cellPhone } = this.state
    return '55' + cellPhone.replace(/\D/g, '')
  }

  checkOnboardingStatus = (login) => {
    this.setState({
      isLookingUpContact: true
    })

    axios({
      url: `${this.onboardingBaseURI}/api/sonar/getinfo`,
      method: 'POST',
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.RAZZLE_ONBOARDING_SUBSCRIPTION_KEY,
        Geolocation: JSON.stringify(OnboardingService.getGeolocation())
      },
      data: {
        documentNumber: login,
        projectId: this.campaignId
      }
    })
      .then((response) => {
        const result = response.data.data
        this.setState({ isLookingUpContact: false })
        if (result.step === 1) {
          this.setState({ isSendEmail: true })
        } else if (result.step === 2) {
          this.setState({ isSendSMS: true })
        } else if (result.step === 3) {
          this.setState({ isSendDocument: true })
        } else if (result.step === 4) {
          this.removeCookie()
          this.setState({ isApprovedOnboarding: true })
        } else if (result.step === 5) {
          this.removeCookie()
          this.setState({
            isExistsOnboardingBox: true,
            onboardingId: result.onboardingId,
            createDate: moment(result.createDate).format('DD/MM/YYYY HH:mm')
          })
        } else {
          this.removeCookie()
          this.setState({ isError: true })
        }
      })
      .catch((err) => {
        this.removeCookie()
        this.setState({
          isError: true,
          isLookingUpContact: false
        })
      })
  }

  handleChange = ({ target: { name, value } }) => {
    this.setState({ [name]: value, error: undefined })
  }

  validationForm(name, value) {
    const { error } = this.state
    let result = error

    if (name === 'emailAddress' && value && value.length > 0) {
      if (!ValidationRules.isValidEmail(value)) {
        result = new Error('Digite um E-mail válido.')
      } else {
        result = null
      }
    }

    if (name === 'cellPhone' && value) {
      if (!ValidationRules.isValidCellPhone(value)) {
        result = new Error('Digite um Celular válido.')
      } else {
        result = null
      }
    }
    this.setState({
      error: result
    })
  }

  handleSubmitRegister = () => {
    this.setState({ isLookingUpContact: true })

    const { emailAddress, login } = this.state

    var emailValid = emailAddress.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)

    if (!emailValid) {
      this.setState({
        error: new Error('E-mail invalido.'),
        isLookingUpContact: false
      })
      return
    }

    axios({
      url: `${this.onboardingBaseURI}/api/sonar/token/email`,
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.RAZZLE_ONBOARDING_SUBSCRIPTION_KEY,
        Geolocation: JSON.stringify(OnboardingService.getGeolocation())
      },
      data: {
        contact: emailAddress,
        campaignId: this.campaignId,
        documentNumber: login
      },
      method: 'POST'
    })
      .then((response) => {
        if (response.data.data.send) {
          this.setState({
            timeLeft: 180,
            idTransaction: response.data.data.transactionId,
            isResend: true,
            isLookingUpContact: false,
            isEnableToken: true,
            error: undefined
          })

          this.startTimer()
        } else {
          this.setState({
            error: new Error('Erro ao enviar token. Tente novamente mais tarde.'),
            isLookingUpContact: false
          })
        }
      })
      .catch((err) => {
        const msgErro = err.response.data.errors[0]
        this.setState({
          error: new Error(
            msgErro && msgErro.message ? msgErro.message : 'Erro ao enviar token. Tente novamente mais tarde.'
          ),
          isLookingUpContact: false
        })
      })
  }

  handleSubmitRegisterSms = () => {
    this.setState({ isLookingUpContact: true })

    const { cellPhone, login } = this.state

    if (!cellPhone) {
      this.setState({
        error: new Error('Celular invalido.'),
        isLookingUpContact: false
      })
      return
    }

    axios({
      url: `${this.onboardingBaseURI}/api/sonar/token/phone`,
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.RAZZLE_ONBOARDING_SUBSCRIPTION_KEY,
        Geolocation: JSON.stringify(OnboardingService.getGeolocation())
      },
      data: {
        contact: this.unmaskedCellphone,
        campaignId: this.campaignId,
        documentNumber: login
      },
      method: 'POST'
    })
      .then((response) => {
        if (response.data.data.send) {
          this.setState({
            timeLeft: 180,
            idTransactionSms: response.data.data.transactionId,
            isResendSMS: true,
            isLookingUpContact: false,
            isEnableToken: true,
            error: undefined
          })
          this.startTimer()
        } else {
          this.setState({
            error: new Error('Erro ao enviar token. Tente novamente mais tarde.'),
            isLookingUpContact: false
          })
        }
      })
      .catch((err) => {
        const msgErro = err.response.data.errors[0]
        this.setState({
          error: new Error(
            msgErro && msgErro.message ? msgErro.message : 'Erro ao enviar token. Tente novamente mais tarde.'
          ),
          isLookingUpContact: false
        })
      })
  }

  handleBackRecovery = () => this.setState({ isResend: false })

  handleBackToHome = () => this.setState({ isResend: false, isResendSMS: false, isSendSMS: false })

  handleBackRecoverySms = () => this.setState({ isResendSMS: false })

  handleSendToken = () => {
    this.setState({ isLookingUpContact: true })

    const { idTransaction, login, token, emailAddress } = this.state

    axios({
      url: `${this.onboardingBaseURI}/api/sonar/token/email/validate`,
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.RAZZLE_ONBOARDING_SUBSCRIPTION_KEY,
        Geolocation: JSON.stringify(OnboardingService.getGeolocation())
      },
      data: {
        contact: emailAddress,
        campaignId: this.campaignId,
        documentNumber: login,
        token: token,
        transactionId: idTransaction
      },
      method: 'POST'
    })
      .then((response) => {
        if (response.data.data.success) {
          this.setState({
            isSendSMS: true,
            isLookingUpContact: false,
            error: undefined
          })
        } else {
          this.setState({
            error: new Error('Erro ao validar token.'),
            isLookingUpContact: false
          })
        }
      })
      .catch((err) => {
        this.setState({
          error: new Error('Erro ao validar token.'),
          isLookingUpContact: false
        })
      })
  }

  handleSendTokenSms = () => {
    this.setState({ isLookingUpContact: true })

    const { idTransactionSms, login, tokenSms } = this.state

    axios({
      url: `${this.onboardingBaseURI}/api/sonar/token/phone/validate`,
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.RAZZLE_ONBOARDING_SUBSCRIPTION_KEY,
        Geolocation: JSON.stringify(OnboardingService.getGeolocation())
      },
      data: {
        contact: this.unmaskedCellphone,
        campaignId: this.campaignId,
        documentNumber: login,
        token: tokenSms,
        transactionId: idTransactionSms
      },
      method: 'POST'
    })
      .then((response) => {
        if (response.data.data.success) {
          if (response.data.data.concluedRegister) {
            this.removeCookie()
            this.setState({
              isConfirmation: true,
              isLookingUpContact: false,
              error: undefined
            })
          } else {
            this.setState({
              isSendDocument: true,
              isLookingUpContact: false,
              error: undefined
            })
          }
        } else {
          this.setState({
            error: new Error('Token inválido.'),
            isLookingUpContact: false
          })
        }
      })
      .catch((err) => {
        this.setState({
          error: new Error('Erro ao validar token.'),
          isLookingUpContact: false
        })
      })
  }

  handleDropFileFront = (acceptedFiles) => {
    this.onDropFile(acceptedFiles, 1)
  }

  handleDropFileBack = (acceptedFiles) => {
    this.onDropFile(acceptedFiles, 2)
  }

  onDropFile = (acceptedFiles, type) => {
    if (acceptedFiles.length > 0 && acceptedFiles.length <= 2) {
      const { filesUpload } = this.state
      let files = filesUpload
      acceptedFiles.forEach((file) => {
        const reader = new FileReader()
        reader.onload = (event) => {
          if (event.target.result.split(`,`).length >= 2) {
            const idx = files.findIndex((x) => x.type === type)
            if (idx >= 0) {
              files.splice(idx, 1)
            }
            files.push({
              image: event.target.result.split(`,`)[1],
              type: type,
              name: file.name
            })
            if (files.length === 2) {
              this.setState({ hasFile: true })
            }
            this.setState({
              filesUpload: files,
              error: undefined
            })
          } else {
            this.setState({ error: new Error('Erro processar.') })
          }
        }
        reader.readAsDataURL(file)
      })
    } else {
      const { filesUpload } = this.state
      let files = filesUpload
      const idx = files.findIndex((x) => x.type === type)
      if (idx >= 0) {
        files.splice(idx, 1)
      }
      this.setState({
        filesUpload: files,
        hasFile: false,
        error: new Error('O documento pode ter no máximo 4Mb.')
      })
    }
  }

  handleUploadFile = () => {
    this.setState({ isLookingUpContact: true })

    const { filesUpload, login } = this.state

    if (filesUpload.length !== 2) {
      this.setState({
        error: new Error('É obrigatório o envio do documento frente e verso.'),
        isLookingUpContact: false
      })
      return
    }

    let formData = {
      documentNumber: login,
      campaignId: Number(this.campaignId),
      documents: filesUpload
    }

    axios({
      url: `${this.onboardingBaseURI}/api/sonar/documents`,
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.RAZZLE_ONBOARDING_SUBSCRIPTION_KEY,
        Geolocation: JSON.stringify(OnboardingService.getGeolocation())
      },
      data: formData,
      method: 'POST'
    })
      .then((response) => {
        if (response.data.data.success) {
          axios({
            url: `${this.onboardingBaseURI}/api/sonar/finalize`,
            headers: {
              'Ocp-Apim-Subscription-Key': process.env.RAZZLE_ONBOARDING_SUBSCRIPTION_KEY,
              Geolocation: JSON.stringify(OnboardingService.getGeolocation())
            },
            data: {
              documentNumber: login,
              projectId: this.campaignId
            },
            method: 'POST'
          })
            .then((response) => {
              if (response.data.data.success) {
                this.removeCookie()
                this.setState({
                  isConfirmationWithFiles: true,
                  error: undefined
                })
              } else {
                this.setState({
                  error: new Error('Erro ao salvar.'),
                  isLookingUpContact: false
                })
              }
            })
            .catch((err) => {
              this.setState({
                error: new Error('Erro ao salvar.'),
                isLookingUpContact: false
              })
            })
        } else {
          this.setState({
            error: new Error('Erro ao enviar arquivos.'),
            isLookingUpContact: false
          })
        }
      })
      .catch((err) => {
        this.setState({
          error: new Error('Erro ao salvar.'),
          isLookingUpContact: false
        })
      })
  }

  countDown() {
    this.setState({ timeLeft: this.state.timeLeft - 1 })
    if (this.state.timeLeft === 0) {
      clearInterval(this.state.timer)
      this.setState({ isEnableToken: false })
    }
  }

  startTimer() {
    this.setState({
      timer: setInterval(() => {
        this.countDown()
      }, 1000)
    })
  }

  removeCookie() {
    document.cookie = `${onboardingCookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
  }

  render() {
    return (
      <Layout>
        <RecoveryForm
          {...this.state}
          handleChange={this.handleChange}
          handleSubmitRegister={this.handleSubmitRegister}
          handleSubmitRegisterSms={this.handleSubmitRegisterSms}
          handleBackRecovery={this.handleBackRecovery}
          handleBackRecoverySms={this.handleBackRecoverySms}
          handleBackToHome={this.handleBackToHome}
          handleSendToken={this.handleSendToken}
          handleSendTokenSms={this.handleSendTokenSms}
          handleUploadFile={this.handleUploadFile}
          handleDropFileFront={this.handleDropFileFront}
          handleDropFileBack={this.handleDropFileBack}
          handleValidate={(name, value) => this.validationForm(name, value)}
        />
      </Layout>
    )
  }
}

export default RecoveryAccessPage
